import { LitElement, html, css, render } from 'lit';
import { msg } from '@lit/localize';
import { search }  from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInMembersSearch extends AllInOrganisationConsumer(LitElement) {
    static properties = {
        name: {type:String},
        loading: {type:Boolean,state:true},
        restUrl: {type:String},
        nonce: {type:String},
        _members: {type:Array,state:true},
        useSearchInterface: {type:Boolean,state:true},
        hasSearched: {type:Boolean,state:true},
        surname: {type:String,state:true},
        errorMessage: {type:String,state:true},
    }
    constructor() {
        super();
        this._members = [];
        this.loading = false;
        this.hasSearched = false;
        this.useSearchInterface = true;
        this.surname = '';
        this.errorMessage = '';
    }

    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-search-members-clear-${this.name}`, async (e) => {
                this.searchElement = this.renderRoot.querySelectorAll('input');
                if(this.searchElement.length){
                    this.searchElement.forEach(input => input.value = '');
                }
                this.useSearchInterface = true;
                this.hasSearched = false;
                this._members = [];
                this.errorMessage = '';
        });
    }

    createRenderRoot() { 
        return this;
    }

    get input(){
        return this.renderRoot.querySelector('input[name="member_id"]');
    }

    updated(changedProperties){
    }

    render(){
        let main=html`
            <div class="allin-members-search-form ${this.loading?"loading":""}" ?aria-busy=${this.loading} >
                <div class="searchboxes ${this.useSearchInterface ? '' : 'hide'}">
                    <div class="searchbox">
                        <label for="allin-members-surname-search">${this.searchByText || msg("Search for a member by surname")}</label>
                        <input type="text" id="allin-members-surname-search" name="member_surname" @keydown=${(e) => this._handleKeydown(e,'name')}/>
                    </div>
                    <button class="button" ?disabled=${this.loading} @click=${(e) => this._handleSubmit(e,'name')}>${msg(`Search`)}</button>
                    ${this.errorMessage ? html`<div class="error-message">${this.errorMessage}</div>` : ''}
                </div>
                <div class="flex space-between wrap ${this.hasSearched && this.useSearchInterface ? '' : 'hide'}" style="max-width: 800px;">
                    <h4>${msg(`Can't find your member?`)}</h4>
                    <button class="clear" @click=${(e) => this._handleSwitchModes(e)}>${msg('Search all of All In')}
                </button></div>
                <div class="searchboxes ${!this.useSearchInterface ? '' : 'hide'}">
                    <div class="searchbox">
                        <label for="allin-members-id-lookup">${msg("Enter the member's All In Member Number.")}</label>
                        <input type="text" id="allin-members-id-lookup" name="member_id" aria-required="true" />
                        <label for="allin-members-surname-lookup">${msg("Enter the member's full surname.")}</label>
                        <input type="text" id="allin-members-surname-lookup" name="member_surname" aria-required="true" value=${this.surname}/>
                    </div>
                    <button class="button" ?disabled=${this.loading} @click=${(e) => this._handleSubmit(e,'id')}>${msg(`Search`)}</button>
                    ${this.errorMessage ? html`<div class="error-message">${this.errorMessage}</div>` : ''}
                </div>
            </div>
        `;

        return html`
            <input type="hidden" name="member_id">
            <div class="bg">
                ${main}
            </div>
        `;
    }

    async _handleSubmit(e, type){
        e.preventDefault();
        this.loading = true;
        this.errorMessage = '';
        let action = type==='id' ? 'get_member_by_allin_member_number' : 'get_search_members';
        const params = new URLSearchParams();
        if(type==='id'){
            const idInput = this.renderRoot.querySelector('#allin-members-id-lookup');
            const surnameInput = this.renderRoot.querySelector('#allin-members-surname-lookup');
            const id = idInput?.value?.trim();
            const surname = surnameInput?.value?.trim();
            if(!id || !surname) {
                console.warn('Both ID and surname are required for ID search');
                this.errorMessage = msg(`Both ID and surname are required for search`);
                this.loading = false;
                return;
            }
            params.append('member_id', id);
            params.append('member_surname', surname);
        }
        else if (type==='name'){
            const searchInput = this.renderRoot.querySelector('#allin-members-surname-search');
            const search = searchInput?.value?.trim();
            this.surname = search;
            if(!search || search.length < 3) {
                console.warn('Search term must be at least 3 characters');
                this.errorMessage = msg(`Search term must be at least 3 characters`);
                this.loading = false;
                return;
            }
            params.append('name', search);
            params.append('org_id', this.currentOrg);
        }
        try{
            const response = await fetch(`${this.restUrl}?action=${action}&${params.toString()}`,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            const data = await response.json();

            if(data){
                if(type==='id'){
                    if(data.error){
                        return;
                    }
                    else{
                        this._members = data ? [data] : [];
                    }
                }
                else{
                    this._members = data;
                }

                this.eventManager.emit(`allin-search-results-${this.name}`,{results:this._members, type:type});
            }
        }
        catch(error){
            console.error('Error fetching members:', error);
        }
        finally{
            this.loading = false;
            this.hasSearched = true;
        }
        this.loading = false;
      // this.organisations = this.dummyorganisations;

    }
    

    _selectMember(member){
        this.panel = member.id;
        this._updateContext({panel:this.panel})
    }

    _handleKeydown(e, type){
        if(e.key === 'Enter'){
            e.preventDefault();
            this._handleSubmit(e, type);
        }
    }
    
    _handleClearIDSearch(e){
        e.preventDefault();
        this.hasIDSearched = false;
        const searchInput = this.renderRoot.querySelector('#allin-members-id-search');
        if(searchInput){
            searchInput.value = '';
        }
        this.eventManager.emit(`allin-search-members-clear-${this.name}`);
    }

    _handleSwitchModes(e){
        e.preventDefault();
        this.useSearchInterface = !this.useSearchInterface;
    }
}